module.exports = __webpack_public_path__ + "img/undraw_product_iteration_kjok.b027f82f.png";